import React, { useState } from "react";

export default function DragDropCSV() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return alert("Please select a CSV file!");

    const formData = new FormData();
    formData.append("csv_file", file);

    try {
      const res = await fetch("http://localhost:8000/api/housing/upload-csv/", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const text = await res.text(); // fallback if JSON fails
        throw new Error(`Server error: ${text}`);
      }

      const data = await res.json();
      setResult(data);
      setError(null);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message);
      setResult(null);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h2>Upload CSV</h2>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={handleUpload} style={{ marginLeft: "10px" }}>
        Upload
      </button>

      {result && (
        <pre style={{ marginTop: "20px", background: "#f4f4f4", padding: "10px" }}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}

      {error && (
        <pre style={{ marginTop: "20px", color: "red", background: "#fee", padding: "10px" }}>
          {error}
        </pre>
      )}
    </div>
  );
}
